export const LEAFLINK_ENVIRONMENTS = ['production', 'sandbox'];
//# sourceMappingURL=leaflink-environments.js.map